import AES from "@ali/aes-tracker";
import { mark, measure, markWithEntry, measureWithEntry } from "./polyfill-usertiming";
import { sendUserTimings, sendPaintTimings, sendElementTimings, savePaintTimings, saveLCPTimings, sendResourceTimings } from "./send"; // navigation timing
// 通过异步引入该脚本，并且资源已经下载完，这时会走第一种情况，可以拿到loadEventEnd
// 但是，如果同步引入，或者异步引入时资源未下载完，会走第二种情况，此时没有loadEventEnd

var onLoad = function onLoad(callback) {
  if (document.readyState === "complete") {
    setTimeout(callback);
  } else {
    window.addEventListener("load", function () {
      return setTimeout(callback);
    });
  }
};

var getPerformanceTiming = function getPerformanceTiming() {
  var _window, _window$performance, _window$performance$t;

  if (((_window = window) === null || _window === void 0 ? void 0 : (_window$performance = _window.performance) === null || _window$performance === void 0 ? void 0 : (_window$performance$t = _window$performance.timing) === null || _window$performance$t === void 0 ? void 0 : _window$performance$t.navigationStart) > 0) {
    var timing = {};

    for (var i in performance.timing) {
      // console.log("i", i, performance.timing[i]);
      if (typeof performance.timing[i] === "number" && performance.timing[i] > 0) {
        timing[i] = Math.max(performance.timing[i] - performance.timing.navigationStart, 0);
      }
    }

    return timing;
  }
};

var getPerformanceNavigationTiming = function getPerformanceNavigationTiming() {
  var _window2, _window2$performance;

  if (window.PerformanceNavigationTiming && (_window2 = window) !== null && _window2 !== void 0 && (_window2$performance = _window2.performance) !== null && _window2$performance !== void 0 && _window2$performance.getEntriesByType) {
    var timing = performance.getEntriesByType("navigation")[0];
    var r = {};

    for (var i in timing) {
      // if(i === 'serverTiming'){
      //     timing[i] = timing[i].map(item=>{
      //         if(typeof item === 'number'){
      //             return item.toFixed(2)
      //         }
      //     })
      // }
      if (i === "entryType" || i === "initiatorType" || i === "name" || timing[i] === 0) {
        continue;
      }

      if (typeof timing[i] === "number") {
        r[i] = timing[i].toFixed(2);
      } else if (i === "serverTiming" && timing[i].length) {
        r[i] = [].concat(timing[i]);
      } else if (typeof timing[i] === "string" && timing[i]) {
        r[i] = timing[i];
      }
    }

    return r;
  }
};

var getTiming = function getTiming() {
  return getPerformanceNavigationTiming() || getPerformanceTiming();
};

onLoad(function () {
  var timing = getTiming();

  if (timing && timing.responseStart && timing.responseEnd && timing.responseEnd >= timing.responseStart) {
    AES.log("perf", timing);
  }

  var enableResourceTiming = AES.getConfig('plugin_perf_enableResourceTiming');
  enableResourceTiming && setTimeout(sendResourceTimings, 5000);
}); // 支持lcp，则在页面隐藏/卸载时一起上报fp、fcp、lcp的数据

var watchPageVisibility = function watchPageVisibility() {
  function pageHiddenHandler() {
    if (document.hidden) {
      document.removeEventListener('visibilitychange', pageHiddenHandler, true);
      sendPaintTimings();
    }
  }

  document.addEventListener('visibilitychange', pageHiddenHandler, true);
}; // paint timing、user timing、element timing


var initPerformanceObserver = function initPerformanceObserver() {
  if (!window.PerformanceObserver) {
    return;
  }

  var toObserveList = [];
  var enableUserTimingObserve = AES.getConfig('plugin_perf_enableUserTimingObserve');

  if (enableUserTimingObserve) {
    if (window.PerformanceMark) {
      toObserveList.push('mark');
    }

    if (window.PerformanceMeasure) {
      toObserveList.push('measure');
    }
  }

  if (window.PerformancePaintTiming) {
    toObserveList.push('paint');
  }

  if (window.PerformanceElementTiming) {
    toObserveList.push('element');
  }

  if (window.LargestContentfulPaint) {
    toObserveList.push('largest-contentful-paint');
    watchPageVisibility();
  }

  try {
    (function () {
      var elementMap = {};

      for (var i = 0; i < toObserveList.length; i++) {
        var entryType = toObserveList[i];
        var observer = new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (item) {
            // console.log("item", item);
            switch (item.entryType) {
              case "paint":
                savePaintTimings(item);
                break;

              case "mark":
              case "measure":
                sendUserTimings(item);
                break;

              case "element":
                if (!elementMap[item.identifier]) {
                  elementMap[item.identifier] = 1;
                  sendElementTimings(item);
                }

                break;

              case "largest-contentful-paint":
                saveLCPTimings(item);
                break;
            }
          });
        }); // Safari 对于 mark、measure不支持type 只支持entryType，对于PaintTiming、ElementTiming、LCP都不支持

        try {
          observer.observe({
            type: entryType,
            buffered: true
          });
        } catch (es) {
          // 不支持type时，直接observe所有entryTypes，并跳出循环
          observer.observe({
            entryTypes: toObserveList
          });
          break;
        }
      }
    })();
  } catch (ex) {}
};

initPerformanceObserver();
export { mark, measure, markWithEntry, measureWithEntry };
export default {
  mark: mark,
  measure: measure,
  markWithEntry: markWithEntry,
  measureWithEntry: measureWithEntry
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-perf@1.1.7@@ali/aes-tracker-plugin-perf/es/index.js
// module id = null
// module chunks = 